import client from "../libs/HttpClient";

class SoftwareServices {
  static SoftwareList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/software?page=${page_no}`, request);
  }
  static addSoftware(request) {
    return client.post(`/add-software`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateSoftware(request) {
    return client.post(`/edit-software`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewSoftware(params) {
    return client.get(`/get-software`, { params });
  }
  static deleteSoftware(params) {
    return client.delete(`/delete-software`, { params });
  }
}

export { SoftwareServices };
